import { render, staticRenderFns } from "./newWebForm.vue?vue&type=template&id=44f1ea65&"
import script from "./newWebForm.js?vue&type=script&lang=js&"
export * from "./newWebForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports